import { GetPremiumCTA } from 'components/PremiumCTA/GetPremiumCTA';

import './ModuleLibrary.scss';
import { ModuleCard } from 'components/ModuleCard/ModuleCard';
import { useServices } from 'index';
import { useQuery } from '@tanstack/react-query';
import { ModuleOverview } from 'types/module';
import { ModuleLoaderCard } from 'components/ModuleCard/ModuleLoaderCard/ModuleLoaderCard';

export const ModuleLibrary = () => {
  const learningHubService = useServices().learningHubService;
  const adminPermissionsService = useServices().adminPermissionsService;
  const profileService = useServices().profileService;

  const moduleList = useQuery({ queryKey: ['learningHubModuleList'], queryFn: learningHubService.getModules, refetchOnWindowFocus: false });
  const isAdmin = useQuery({
    queryKey: ['isUserAdmin'],
    queryFn: adminPermissionsService.isAdmin,
    staleTime: Infinity,
  });
  const { data: isUserMember, isPending } = useQuery({
    queryKey: ['isUserMember'],
    queryFn: profileService.checkIfUserIsMember,
    refetchOnWindowFocus: false,
  });

  return (
    <div className='modules-tab'>
      {!isPending && !isUserMember && <GetPremiumCTA />}
      <ModulesGrid modules={moduleList.data} isPending={moduleList.isPending} isAdmin={isAdmin.data ?? false} />
    </div>
  );
};

type ModulesGridProps = {
  modules: ModuleOverview[] | undefined;
  isPending: boolean;
  isAdmin: boolean;
};
const ModulesGrid = ({ modules, isPending, isAdmin }: ModulesGridProps) => {
  return (
    <div className='modules-grid'>
      {!isPending
        ? modules?.map((module) => <ModuleCard key={module.id} module={module} isAdmin={isAdmin} />)
        : Array.from(Array(10)).map((el, index) => <ModuleLoaderCard key={index} />)}
    </div>
  );
};
